import { render, staticRenderFns } from "./TiposFuncionariosLista.vue?vue&type=template&id=520ed626&scoped=true&"
import script from "./TiposFuncionariosLista.vue?vue&type=script&lang=js&"
export * from "./TiposFuncionariosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ed626",
  null
  
)

export default component.exports